$("#sub").click(function() {
    var formData = new FormData($("#scholarshipApplication form")[0]);

    // clear validation msg
    $("#scholarshipApplication .form-group").removeClass("has-error");
    $("#scholarshipApplication .form_validation").html(" ");

    // validation
    var validationNumber = 0;
    var nameF = $("#scholarshipApplication input[name='sFirstName']");
    validationNumber++;
    var nameL = $("#scholarshipApplication input[name='sLastName']");
    validationNumber++;
    var phone = $("#scholarshipApplication input[name='sPhone']");
    validationNumber++;
    var email = $("#scholarshipApplication input[name='sEmail']");
    validationNumber++;
    var address = $("#scholarshipApplication input[name='sAddress']");
    validationNumber++;
    var resume = $("#scholarshipApplication input[name='sResume']");
    validationNumber++;

    // submit msg room
    var submitStatus = $("#scholarshipApplication #sub");


    var info = validationNumber;
    // validation
    if (nameF.val() == "") {
        nameF.parent().addClass("has-error");
        nameF.next().html("Please input your name");
        info--;
    }
    if (!nameL.val()) {
        nameL.parent().addClass("has-error");
        nameL.next().html("Please input your name");
        info--;
    }
    if (!/^[a-zA-Z0-9\._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email.val())) {
        email.parent().addClass("has-error");
        email.next().html("Please input the correct email");
        info--;
    }
    if (address.val() == "") {
        address.parent().addClass("has-error");
        address.next().html("Please input your Address");
        info--;
    }
    if (phone.val().length != 10) {
        phone.parent().addClass("has-error");
        phone.next().html("Please input the correct phone number");
        info--;
    }
    if (resume.val() == "") {
        resume.parent().addClass("has-error");
        resume.next().html("Please upload a resume file (pdf or word only).");
        info--;
    } else {
        if (resume.val().lastIndexOf('.') != -1) { // comfirm it has filename extension. 
            var fileType = resume.val().split(".").slice(-1)[0];
            if (!(fileType == "pdf" || fileType == "doc" || fileType == "docx")) {
                resume.parent().addClass("has-error");
                resume.next().html("PDF or word only, please check.");
                info--;
            }
        } else {
            resume.parent().addClass("has-error");
            resume.next().html("PDF or word only, please check.");
            info--;
        }
    }
    if (info == validationNumber) {

        // create form submit msg
        $("body").append("<div id='form_msg_room'></div>");

        var formMsgRoom = $("#form_msg_room");
        formMsgRoom.append("<div id='form_msg_cover'></div>").append("<div id='form_msg_cont'></div>");
        formMsgRoom.children("#form_msg_cont").append("<div id='form_msg'></div>").append("<a id='form_msg_return' href='/index.html' target='_self'  class='more'>  Homepage</a>");

        var formMsg = $("#form_msg");
        var formReturn = $("#form_msg_return");
        // after click submit, show loading 
        formMsg.html("Submitting...please wait...");


        $.ajax({
            type: "POST",
            // type: "GET", //测试 error,或者 json 都需要 error
            url: "/cams/mvc/guest/scholarship/req", //提交的地址  
            // url: "../../../json/form.json", // 测试
            // dataType: "json", //无用
            //dataType: "formData", // 无用
            data: formData, // 序列化表单值,
            async: false,
            cache: false,
            processData: false,
            contentType: false,
            error: function(request) { //失败的话
                formMsgRoom.hide();
                submitStatus.parent().addClass("has-error");
                submitStatus.next().html("System error.");

            },
            success: function(data) { //成功
                var msg = data.data;
                for (var i = 0; i < msg.length; i++) {

                    if (msg[i].type == "PROC_DONE") {
                        formMsgRoom.show();
                        formMsg.html("Submit <b> successed</b>, we will contact you as soon as possible. You can click the  button below to return homepage.");
                        formReturn.css("display", "block");
                    } else {
                        formMsgRoom.hide();
                        switch (msg[i].type) {
                            case "PROC_VERI_FIRSTNAME_REQ":
                                nameF.parent().addClass("has-error");
                                nameF.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_LASTNAME_REQ":
                                nameL.parent().addClass("has-error");
                                nameL.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_PHONE_REQ":
                                phone.parent().addClass("has-error");
                                phone.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_PHONE_ERR":
                                phone.parent().addClass("has-error");
                                phone.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_ADDRESS_REQ":
                                address.parent().addClass("has-error");
                                address.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_EMAIL_REQ":
                                email.parent().addClass("has-error");
                                email.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_EMAIL_ERR":
                                email.parent().addClass("has-error");
                                email.next().html(msg[i].msg);
                                break;
                            case "PROC_VERI_FILE_REQ":
                                resume.parent().addClass("has-error");
                                resume.next().html(msg[i].msg);
                                break;
                            case "PROC_FAIL_FILE":
                                resume.parent().addClass("has-error");
                                resume.next().html(msg[i].msg);
                                break;
                            default:
                                submitStatus.next().html(msg[i].msg);

                        }
                    }

                }

            }

        });
    }
});